module.exports = __webpack_public_path__ + "img/ashpa_no.f4923da0.png";